export default __webpack_public_path__ + "media/images/tenant/phone_mockup-a2e2dc306551edf51afb4462876ae3e6.png";